import { Skeleton } from "@mui/material";
import useFileTitle from "files/hooks/useFileTitle";

const FileTitle = (props: { fileKey: string }) => {
  const { title, loading } = useFileTitle(props.fileKey);

  if (loading) {
    return <Skeleton variant="text" width={75} />;
  }

  return <>{title}</>;
};

export default FileTitle;
